import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Undo2 } from "lucide-react";

export function UnapproveButton({ onClick, testid = "unapprove-btn", className = "" }) {
  return (
    <button type="button" data-testid={testid} onClick={onClick}
      className={`inline-flex items-center gap-1.5 rounded-full border border-amber-300 bg-white px-3 py-1.5 text-xs font-medium text-amber-800 hover:bg-amber-50 transition-colors ${className}`}>
      <Undo2 className="h-3.5 w-3.5" /> Unapprove
    </button>
  );
}

export function UnapproveDialog({ what = "this", backTo = "review", onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => { setBusy(true); try { await onConfirm(reason.trim()); } finally { setBusy(false); } };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white border-[#EEEFEF] max-w-md" data-testid="unapprove-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Unapprove {what}?</DialogTitle>
          <DialogDescription>It goes back to {backTo} so it can be changed and approved again. Your reason is saved to its history.</DialogDescription>
        </DialogHeader>
        <Textarea autoFocus data-testid="unapprove-reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Why are you unapproving it?" className="min-h-[90px] bg-[#F6F6FD] border-[#EEEFEF]" />
        <DialogFooter>
          <Button variant="outline" data-testid="unapprove-cancel" onClick={onClose} className="rounded-full border-[#EEEFEF]">Keep approved</Button>
          <Button data-testid="unapprove-confirm" disabled={busy || reason.trim().length < 3} onClick={go} className="rounded-full bg-amber-600 text-white hover:bg-amber-700">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Unapprove"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
